<script lang="ts">
  import { enterKeyEvent, getStr } from '../../../../common/util';
  import Text from '../../../common/components/Text.svelte';
  import ProsAndConsItem from './ProsAndConsItem.svelte';

  export let type = 'pros';
  export let itemList = [];

  let inputText;

  $: addButtonDisabled = !inputText || inputText.length === 0;
  $: inputPlaceholderText = {
    pros: getStr('extra.pdp.review.pros.placeholder'),
    cons: getStr('extra.pdp.review.cons.placeholder'),
  }[type];

  function addItem() {
    if (inputText && inputText.length > 0) {
      itemList = [...itemList, inputText];
      inputText = '';
    }
  }
  function removeItem(index) {
    itemList = [...itemList.filter((_, i) => i !== index)];
  }
</script>

<section class="pros-and-cons-container">
  <section class="new-item">
    <input
      placeholder={inputPlaceholderText}
      type="text"
      bind:value={inputText}
      use:enterKeyEvent
      on:enterKey={() => addItem()}
    />
    <button on:click={() => addItem()} disabled={addButtonDisabled}><Text key="extra.pdp.review.add" /> </button>
  </section>
  {#if itemList.length > 0}
    <section class="item-list">
      {#each itemList as label, index}
        <ProsAndConsItem {type} {label} on:delete={() => removeItem(index)} />
      {/each}
    </section>
  {/if}
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .pros-and-cons-container {
    .new-item {
      display: flex;
      align-items: center;
      gap: 8px;

      input {
        border: 1px solid $secondary-gray-02;
        border-radius: 8px;
        padding: 16px;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
      }
      button {
        background-color: $primary-white;
        padding: 15px 36px;
        border: 1px solid $primary-blue;
        border-radius: 100px;
        color: $primary-blue;
        font-weight: 700;
        font-size: 16px;
        line-height: 18px;

        &:disabled {
          filter: grayscale(1) opacity(0.2);
        }
      }
    }
    .item-list {
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
</style>
